import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import AMapVue from '@amap/amap-vue'
import Json from './test/article.json'
import Meta from 'vue-meta'

const json = type => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(Json[type])
    }, 0)
  })
}

Vue.use(Meta)
Vue.use(AMapVue)
Vue.prototype.$api = { json }
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(Element, {
  size: 'small',
  zIndex: 3000
})

/*高度地图组件*/

AMapVue.config.version = '2.0'
AMapVue.config.key = '01d13f4cdfdb6e9eca892dd82b29f0ca'
AMapVue.config.plugins = []
Vue.use(AMapVue)
window._AMapSecurityConfig = {
  securityJsCode: 'a79052b9d30f3371f16d3d647f7b0c2f'
}

new Vue({
  axios,
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
